/* eslint-disable class-methods-use-this */
import { CancelToken } from 'axios';
import { EntityDto } from 'services/dto';
import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpService';
import { CreateUpdateService, PagedServiceRequest, Service, UpdateService } from './dto/service';

class GarageService {
  public async getAll(
    pagedFilterAndSortedRequest: PagedServiceRequest,
    cancelToken?: CancelToken
  ): Promise<PagedResultDto<Service>> {
    const result = await http.get('api/services/app/Service/GetAll', {
      params: pagedFilterAndSortedRequest,
      cancelToken,
    });
    return result.data.result;
  }

  public async changeActive(id: number) {
    await http.post(`api/services/app/Service/ChangeActive?id=${id}`);
  }

  public async create(service: CreateUpdateService): Promise<Service> {
    const result = await http.post('api/services/app/Service/Create', service);
    return result.data.result;
  }

  public async update(service: UpdateService) {
    const result = await http.put('api/services/app/Service/Update', service);
    return result.data.result;
  }

  public async get(entityDto: EntityDto): Promise<Service> {
    const result = await http.get('api/services/app/Service/Get', { params: entityDto });
    return result.data.result;
  }

  public async delete(entityDto: EntityDto) {
    const result = await http.delete('api/services/app/Service/Delete', { params: entityDto });
    return result.data;
  }
}

export default new GarageService();
